import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';

import 'styles/main.scss';
import checkForTouch from './utils/check-for-touch';
import setPortableDevice from './utils/check-portable-device';
import addResizeListener from './utils/window-resize';
import { addElementTouchFix } from './utils/element-fixes';
import Vue2TouchEvents from 'vue2-touch-events'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import { Dialog, Select, Option, OptionGroup, Carousel, CarouselItem, Checkbox, CheckboxGroup, Radio, RadioGroup, DatePicker, TimeSelect, MessageBox, Popover, Input, Collapse, CollapseItem, Switch, Tabs, TabPane, Slider, Tooltip } from 'element-ui';
import 'styles/element-overrides.scss';
import german from 'element-ui/lib/locale/lang/de'
import locale from 'element-ui/lib/locale'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import 'swiper/css/swiper.css'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

Vue.config.productionTip = false
Vue.use(Vue2TouchEvents, {
    swipeTolerance: 100,
})
Vue.use(PerfectScrollbar)
Vue.use(VueAwesomeSwiper)

// element-ui components
locale.use(german)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(Popover)
Vue.use(Input)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Switch)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Slider)
Vue.use(Tooltip)
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;

checkForTouch();
addResizeListener();
addElementTouchFix();
setPortableDevice();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
